import type { SpotLieRound } from "./spotlie.ts";

export const AI_LITERACY_SPOTLIE_DECK_EL: readonly SpotLieRound[] = [
  {
    intro: "Από έναν βοηθό AI που εξηγεί πώς λειτουργούν οι απαντήσεις του:",
    claims: [
      {
        text: "Δημιουργώ απαντήσεις προβλέποντας το πιο πιθανό επόμενο διακριτικό με βάση τα μοτίβα που έμαθα κατά τη διάρκεια της εκπαίδευσης.",
        isLie: false,
        conceptId: "model_theory",
      },
      {
        text: "Σύμφωνα με τον εσωτερικό έλεγχο αξιοπιστίας του OpenAI για το 2023, το GPT-4 έχει ψευδαισθήσεις σε λιγότερο από 1,8% των πραγματικών ερωτημάτων.",
        isLie: true,
        conceptId: "evidence",
      },
      {
        text: "Μπορώ να ακούγομαι με μεγάλη αυτοπεποίθηση παρέχοντας πληροφορίες που είναι πραγματικά ανακριβείς.",
        isLie: false,
        conceptId: "trust_reasoning",
      },
      {
        text: "Ανακτώ ενημερωμένες πληροφορίες από το ζωντανό διαδίκτυο πριν διατυπώσω κάθε απάντησή μου.",
        isLie: true,
        conceptId: "trust_reasoning",
      },
      {
        text: "Τα δεδομένα εκπαίδευσής μου έχουν ημερομηνία λήξης γνώσεων, επομένως μπορεί να μην γνωρίζω τα πρόσφατα γεγονότα.",
        isLie: false,
        conceptId: "model_theory",
      },
      {
        text: "Χρησιμοποιώ μια κατοχυρωμένη με δίπλωμα ευρεσιτεχνίας κβαντική νευρωνική αρχιτεκτονική που εξαλείφει την παραμόρφωση από το σχεδιασμό.",
        isLie: true,
        conceptId: "model_theory",
      },
    ],
  },
  {
    intro:
      "Από ένα φυλλάδιο προϊόντων τεχνητής νοημοσύνης που υποστηρίζει ότι ο βοηθός του «καταλαβαίνει» πραγματικά τη γλώσσα:",
    claims: [
      {
        text: "Η αρχιτεκτονική του μετασχηματιστή επιτρέπει σε ένα μοντέλο να σταθμίζει τη συνάφεια όλων των διακριτικών στο παράθυρο περιβάλλοντος του ταυτόχρονα.",
        isLie: false,
        conceptId: "model_theory",
      },
      {
        text: "Το μοντέλο μας πέτυχε ποσοστό επιτυχίας στο Turing Test 89% σε διπλές τυφλές δοκιμές που πραγματοποιήθηκαν στο Media Lab του MIT τον Απρίλιο του 2022.",
        isLie: true,
        conceptId: "evidence",
      },
      {
        text: "Τα μεγάλα γλωσσικά μοντέλα δεν έχουν πεποιθήσεις ή προθέσεις. παράγουν στατιστικά εύλογες συνέχειες του κειμένου.",
        isLie: false,
        conceptId: "model_theory",
      },
      {
        text: "Το σύστημά μας έχει πιστοποιηθεί ανεξάρτητα για να ταιριάζει με την ακρίβεια του ιατρού με πιστοποίηση σε όλα τα κλινικά σημεία αναφοράς που έχουν ελεγχθεί.",
        isLie: true,
        conceptId: "evidence",
      },
      {
        text: "Οι LLM μπορούν να αντιμετωπίσουν εργασίες που απαιτούν γνήσια αιτιολογική αιτιολογία ή επίμονη μνήμη σε όλες τις συνεδρίες.",
        isLie: false,
        conceptId: "model_theory",
      },
    ],
  },
  {
    intro: "Από τη σελίδα βοήθειας απορρήτου μιας δημοφιλής υπηρεσίας chatbot AI:",
    claims: [
      {
        text: "Οι συνομιλίες που έχετε με την τεχνητή νοημοσύνη μας ενδέχεται να ελεγχθούν από ανθρώπινους εργολάβους για τη βελτίωση της ποιότητας του μοντέλου.",
        isLie: false,
        conceptId: "privacy",
      },
      {
        text: "Όλα τα δεδομένα αποθηκεύονται αποκλειστικά εντός της ΕΕ από προεπιλογή, παρέχοντας σε κάθε χρήστη αυτόματη προστασία GDPR.",
        isLie: true,
        conceptId: "privacy",
      },
      {
        text: "Η υπηρεσία μας είναι πλήρως συμβατή με το HIPAA, καθιστώντας ασφαλή τη συζήτηση σχετικά με τις πληροφορίες για την υγεία των ασθενών.",
        isLie: true,
        conceptId: "privacy",
      },
      {
        text: "Μπορείτε να ζητήσετε τη διαγραφή των προσωπικών σας δεδομένων σύμφωνα με τους ισχύοντες κανονισμούς προστασίας δεδομένων.",
        isLie: false,
        conceptId: "privacy",
      },
      {
        text: "Όλα τα ερωτήματα των χρηστών είναι κρυπτογραφημένα από άκρο σε άκρο και είναι τεχνικά αδύνατο να τα διαβάσει το προσωπικό μας.",
        isLie: true,
        conceptId: "privacy",
      },
      {
        text: "Δεν πουλάμε τα προσωπικά σας δεδομένα σε τρίτους διαφημιστές.",
        isLie: false,
        conceptId: "privacy",
      },
    ],
  },
  {
    intro:
      "Από μια ανάρτηση ιστολογίου σχετικά με τους κινδύνους άμεσης έγχυσης σε πράκτορες τεχνητής νοημοσύνης:",
    claims: [
      {
        text: "Η άμεση έγχυση συμβαίνει όταν κακόβουλες οδηγίες που κρύβονται σε εξωτερικά δεδομένα χειραγωγούν τη συμπεριφορά ενός πράκτορα AI.",
        isLie: false,
        conceptId: "adversarial",
      },
      {
        text: "Το Top 10 του OWASP για Εφαρμογές LLM αναφέρει την άμεση έγχυση ως τον υπ' αριθμόν ένα κίνδυνο ασφάλειας για συστήματα που τροφοδοτούνται από LLM.",
        isLie: false,
        conceptId: "adversarial",
      },
      {
        text: "Μια μελέτη του Google DeepMind που δημοσιεύτηκε τον Μάρτιο του 2024 απέδειξε ότι η εκπαίδευση RLHF εξαλείφει πλήρως τα τρωτά σημεία έγχυσης έγχυσης.",
        isLie: true,
        conceptId: "evidence",
      },
      {
        text: "Ένας εισβολέας μπορεί να δημιουργήσει ένα κακόβουλο έγγραφο για να κάνει έναν πράκτορα LLM να διεισδύσει σε ευαίσθητο περιβάλλον από τη σύνοδό του.",
        isLie: false,
        conceptId: "adversarial",
      },
      {
        text: "Κανένα πραγματικό περιστατικό ασφάλειας που να περιλαμβάνει άμεση έγχυση δεν έχει ποτέ δημοσιοποιηθεί.",
        isLie: true,
        conceptId: "adversarial",
      },
    ],
  },
  {
    intro:
      "Από μια ανάρτηση παρουσίασης προϊόντος σχετικά με έναν βοηθό επαυξημένης γενιάς ανάκτησης (RAG):",
    claims: [
      {
        text: "Τα συστήματα RAG ανακτούν σχετικά έγγραφα από μια βάση γνώσεων πριν δημιουργήσουν μια απάντηση.",
        isLie: false,
        conceptId: "retrieval",
      },
      {
        text: "Ένα επαυξημένο μοντέλο ανάκτησης θα παράγει πάντα πιο ακριβείς απαντήσεις από ένα αμιγώς παραμετρικό μοντέλο στο ίδιο ερώτημα.",
        isLie: true,
        conceptId: "retrieval",
      },
      {
        text: "Ο αγωγός RAG μας ελέγχθηκε από το Stanford NLP το 1ο τρίμηνο του 2024 και πιστοποιήθηκε με 99,1% πραγματική ακρίβεια.",
        isLie: true,
        conceptId: "evidence",
      },
      {
        text: "Η στρατηγική τμηματοποίησης και η ποιότητα ενσωμάτωσης επηρεάζουν σημαντικά το περιεχόμενο που ανακτά ένα σύστημα RAG.",
        isLie: false,
        conceptId: "retrieval",
      },
      {
        text: "Η ψευδαίσθηση είναι αδύνατη σε ένα σωστά διαμορφωμένο σύστημα RAG επειδή το μοντέλο διαβάζει μόνο το ανακτηθέν κείμενο.",
        isLie: true,
        conceptId: "trust_reasoning",
      },
      {
        text: "Ένας πράκτορας τεχνητής νοημοσύνης με πρόσβαση εργαλείων μπορεί να κάνει πραγματικές ενέργειες, όπως η αποστολή email ή η τροποποίηση αρχείων.",
        isLie: false,
        conceptId: "tools_agents",
      },
    ],
  },
  {
    intro: "Από ένα εισαγωγικό άρθρο σχετικά με το πώς εκπαιδεύονται τα μοντέλα γλώσσας AI:",
    claims: [
      {
        text: "Τα LLM είναι προεκπαιδευμένα σε μεγάλα σώματα κειμένου χρησιμοποιώντας έναν επόμενο στόχο πρόβλεψης.",
        isLie: false,
        conceptId: "foundations",
      },
      {
        text: "Το GPT-4 εκπαιδεύτηκε αποκλειστικά σε 45 terabytes επιστημονικής βιβλιογραφίας με κριτές από ομοτίμους που επιμελήθηκαν ερευνητές του OpenAI.",
        isLie: true,
        conceptId: "evidence",
      },
      {
        text: "Η κλιμάκωση του μεγέθους του μοντέλου και του μεγέθους δεδομένων γενικά βελτιώνει την απόδοση, μια τάση που μελετάται στην έρευνα για τους «νόμους της νευρικής κλίμακας».",
        isLie: false,
        conceptId: "foundations",
      },
      {
        text: "Μόλις αναπτυχθεί, ένα LLM ενημερώνει συνεχώς τα βάρη του σε πραγματικό χρόνο με βάση τα σχόλια των συνομιλιών των χρηστών.",
        isLie: true,
        conceptId: "model_theory",
      },
      {
        text: "Το RLHF (Reinforcement Learning from Human Feedback) χρησιμοποιείται για την ευθυγράμμιση των αποτελεσμάτων του μοντέλου με τις ανθρώπινες προτιμήσεις.",
        isLie: false,
        conceptId: "foundations",
      },
    ],
  },
  {
    intro: "Από έναν εταιρικό οδηγό ανάπτυξης AI για την ασφαλή επιχειρηματική χρήση των LLM:",
    claims: [
      {
        text: "Οι αποφάσεις τεχνητής νοημοσύνης υψηλού στοιχήματος θα πρέπει να περιλαμβάνουν έναν εξειδικευμένο ανθρώπινο κριτή στο βρόχο.",
        isLie: false,
        conceptId: "system_safety",
      },
      {
        text: "Η συνταγματική τεχνητή νοημοσύνη, που αναπτύχθηκε από την Anthropic, είναι η τεχνική που χρησιμοποιήθηκε για πρώτη φορά για να ευθυγραμμιστεί η τεχνητή νοημοσύνη με τις ανθρώπινες αξίες, που προέρχεται από ένα έγγραφο του NeurIPS του 1997.",
        isLie: true,
        conceptId: "evidence",
      },
      {
        text: "Η λεπτομέρεια ασφαλείας μπορεί να μειώσει σημαντικά, αλλά όχι να αποτρέψει πλήρως τα επιβλαβή αποτελέσματα από ένα μοντέλο γλώσσας.",
        isLie: false,
        conceptId: "system_safety",
      },
      {
        text: "Η ανάπτυξη ενός LLM με στοιχεία ελέγχου πρόσβασης που βασίζονται σε ρόλους περιορίζει τα δεδομένα που μπορεί να ανακτήσει και να ενεργήσει το μοντέλο.",
        isLie: false,
        conceptId: "system_safety",
      },
      {
        text: "Κάθε LLM που περνά ένα δημοσιευμένο σημείο αναφοράς ασφάλειας είναι πιστοποιημένο ασφαλές για όλα τα περιβάλλοντα ανάπτυξης της επιχείρησης.",
        isLie: true,
        conceptId: "system_safety",
      },
    ],
  },
] as const;
